"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * Copyright 2025 Scott Bender (scott@scottbender.net)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const observable_hooks_1 = require("observable-hooks");
const react_1 = __importStar(require("react"));
const reactstrap_1 = require("reactstrap");
const Filters_1 = require("./Filters");
const DataList = (props) => {
    const data = (0, observable_hooks_1.useObservableState)(props.data);
    const filter = (0, observable_hooks_1.useObservableState)(props.filter);
    const doFiltering = (0, observable_hooks_1.useObservableState)(props.doFiltering);
    const filterOptions = (0, observable_hooks_1.useObservableState)(props.filterOptions);
    const [expandedRows, setExpandedRows] = (0, react_1.useState)(new Set());
    const [sortConfig, setSortConfig] = (0, react_1.useState)({ column: 'src', direction: 'asc' });
    const filterConfig = (0, Filters_1.getFilterConfig)(filter);
    const addToFilteredPgns = (0, react_1.useCallback)((i) => {
        const safeFilteredPgns = filter?.pgn || [];
        if (safeFilteredPgns.indexOf(i) === -1) {
            props.filter.next({ ...filter, pgn: [...safeFilteredPgns, i] });
        }
    }, [filter, props.filter]);
    const addToFilteredSrcs = (0, react_1.useCallback)((src) => {
        const safeFilteredSrcs = filter?.src || [];
        if (safeFilteredSrcs.indexOf(src) === -1) {
            props.filter.next({ ...filter, src: [...safeFilteredSrcs, src] });
        }
    }, [filter, props.filter]);
    const toggleRowExpansion = (0, react_1.useCallback)((rowKey) => {
        setExpandedRows((prev) => {
            const newSet = new Set(prev);
            if (newSet.has(rowKey)) {
                newSet.delete(rowKey);
            }
            else {
                newSet.add(rowKey);
            }
            return newSet;
        });
    }, []);
    const handleSort = (0, react_1.useCallback)((column) => {
        setSortConfig((prev) => ({
            column,
            direction: prev.column === column && prev.direction === 'asc' ? 'desc' : 'asc',
        }));
    }, []);
    const getSortedEntries = (0, react_1.useCallback)((entries) => {
        return entries.sort(([, a], [, b]) => {
            let comparison = 0;
            switch (sortConfig.column) {
                case 'timestamp':
                    const timeA = new Date(a.current.timestamp || 0).getTime();
                    const timeB = new Date(b.current.timestamp || 0).getTime();
                    comparison = timeA - timeB;
                    break;
                case 'pgn':
                    comparison = a.current.pgn - b.current.pgn;
                    break;
                case 'src':
                    comparison = (a.current.src || 0) - (b.current.src || 0);
                    break;
                case 'dst':
                    comparison = (a.current.dst || 0) - (b.current.dst || 0);
                    break;
                case 'description':
                    const descA = a.current.getDefinition().Description.toLowerCase();
                    const descB = b.current.getDefinition().Description.toLowerCase();
                    comparison = descA.localeCompare(descB);
                    break;
            }
            return sortConfig.direction === 'asc' ? comparison : -comparison;
        });
    }, [sortConfig]);
    const getSortIcon = (0, react_1.useCallback)((column) => {
        if (sortConfig.column !== column) {
            return (0, jsx_runtime_1.jsx)("i", { className: "fas fa-sort", style: { color: '#ccc', marginLeft: '4px' } });
        }
        return ((0, jsx_runtime_1.jsx)("i", { className: `fas fa-sort-${sortConfig.direction === 'asc' ? 'up' : 'down'}`, style: { marginLeft: '4px' } }));
    }, [sortConfig]);
    const handleRowClick = (0, react_1.useCallback)((row) => {
        props.onRowClicked(row);
    }, [props.onRowClicked]);
    const handlePgnClick = (0, react_1.useCallback)((e, pgnString) => {
        e.preventDefault();
        e.stopPropagation();
        addToFilteredPgns(pgnString);
    }, [addToFilteredPgns]);
    const handleSrcClick = (0, react_1.useCallback)((e, src) => {
        e.preventDefault();
        e.stopPropagation();
        addToFilteredSrcs(src);
    }, [addToFilteredSrcs]);
    const handleDescriptionClick = (0, react_1.useCallback)((e, row) => {
        e.preventDefault();
        e.stopPropagation();
        handleRowClick(row);
    }, [handleRowClick]);
    return ((0, jsx_runtime_1.jsx)("div", { style: {
            width: '100%',
            height: '600px',
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column',
        }, children: (0, jsx_runtime_1.jsxs)(reactstrap_1.Table, { responsive: true, bordered: true, size: "sm", children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("th", { style: { width: '55px' } }), (0, jsx_runtime_1.jsxs)("th", { style: { cursor: 'pointer', userSelect: 'none', minWidth: '0px', whiteSpace: 'nowrap' }, onClick: () => handleSort('timestamp'), children: ["Timestamp", getSortIcon('timestamp')] }), (0, jsx_runtime_1.jsxs)("th", { style: { cursor: 'pointer', userSelect: 'none', minWidth: '0px', whiteSpace: 'nowrap' }, onClick: () => handleSort('pgn'), children: ["pgn", getSortIcon('pgn')] }), (0, jsx_runtime_1.jsxs)("th", { style: { cursor: 'pointer', userSelect: 'none', minWidth: '0px', whiteSpace: 'nowrap' }, onClick: () => handleSort('src'), children: ["src", getSortIcon('src')] }), (0, jsx_runtime_1.jsxs)("th", { style: { cursor: 'pointer', userSelect: 'none', minWidth: '0px', whiteSpace: 'nowrap' }, onClick: () => handleSort('dst'), children: ["dst", getSortIcon('dst')] }), (0, jsx_runtime_1.jsxs)("th", { style: { cursor: 'pointer', userSelect: 'none', minWidth: '0px', whiteSpace: 'nowrap' }, onClick: () => handleSort('description'), children: ["Description", getSortIcon('description')] })] }) }), (0, jsx_runtime_1.jsx)("tbody", { children: getSortedEntries((data != undefined ? Object.entries(data) : []).filter(([, entry]) => (0, Filters_1.filterFor)(doFiltering, filterConfig)(entry.current))).map(([rowKey, entry], index) => {
                        const row = entry.current;
                        const isExpanded = expandedRows.has(rowKey);
                        const hasHistory = entry.history.length > 0;
                        const isEvenRow = index % 2 === 0;
                        return ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsxs)("tr", { style: { backgroundColor: isEvenRow ? '#ffffff' : 'rgba(0,0,0,.05)' }, children: [(0, jsx_runtime_1.jsxs)("td", { children: [hasHistory && ((0, jsx_runtime_1.jsx)("i", { className: `fas fa-chevron-${isExpanded ? 'down' : 'right'}`, style: { cursor: 'pointer' }, onClick: () => toggleRowExpansion(rowKey) })), hasHistory && ((0, jsx_runtime_1.jsx)(reactstrap_1.Badge, { color: "info", size: "sm", className: "ms-1", title: `${entry.history.length} previous entries`, children: entry.history.length }))] }), (0, jsx_runtime_1.jsx)("td", { style: { fontFamily: 'monospace', cursor: 'pointer' }, onClick: () => handleRowClick(row), children: new Date(row.timestamp).toLocaleTimeString([], { hour12: false }) }), (0, jsx_runtime_1.jsx)("td", { style: {
                                                color: 'red',
                                                cursor: 'pointer',
                                                fontWeight: hasHistory ? 'bold' : 'normal',
                                            }, onMouseDown: (e) => handlePgnClick(e, row.pgn.toString()), children: row.pgn }), (0, jsx_runtime_1.jsx)("td", { style: { color: 'red', cursor: 'pointer' }, onMouseDown: (e) => handleSrcClick(e, row.src), children: row.sent ? 'self' : row.src }), (0, jsx_runtime_1.jsx)("td", { children: row.dst }), (0, jsx_runtime_1.jsx)("td", { onMouseDown: (e) => handleDescriptionClick(e, row), style: { cursor: 'pointer' }, children: (0, jsx_runtime_1.jsx)("span", { style: { fontFamily: 'monospace' }, children: row.getDefinition().Description }) })] }), hasHistory && ((0, jsx_runtime_1.jsx)("tr", { style: { backgroundColor: 'transparent' }, children: (0, jsx_runtime_1.jsx)("td", { colSpan: 6, style: { padding: 0, borderTop: 'none', backgroundColor: 'transparent' }, children: (0, jsx_runtime_1.jsx)(reactstrap_1.Collapse, { isOpen: isExpanded, children: (0, jsx_runtime_1.jsxs)("div", { style: { backgroundColor: '#f8f9fa', padding: '8px' }, children: [(0, jsx_runtime_1.jsxs)("div", { style: { marginBottom: '8px', fontSize: '0.875rem', fontWeight: 'bold' }, children: ["History (", entry.history.length, " previous entries):"] }), (0, jsx_runtime_1.jsxs)(reactstrap_1.Table, { size: "sm", bordered: true, style: { marginBottom: 0 }, children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { style: { backgroundColor: '#e9ecef' }, children: [(0, jsx_runtime_1.jsx)("th", { children: "Timestamp" }), (0, jsx_runtime_1.jsx)("th", { children: "pgn" }), (0, jsx_runtime_1.jsx)("th", { children: "src" }), (0, jsx_runtime_1.jsx)("th", { children: "dst" }), (0, jsx_runtime_1.jsx)("th", { children: "Description" })] }) }), (0, jsx_runtime_1.jsx)("tbody", { children: entry.history.map((historicalRow, index) => ((0, jsx_runtime_1.jsxs)("tr", { style: { cursor: 'pointer' }, onClick: () => handleRowClick(historicalRow), children: [(0, jsx_runtime_1.jsx)("td", { style: { fontFamily: 'monospace', fontSize: '0.8rem' }, children: new Date(historicalRow.timestamp).toLocaleTimeString([], { hour12: false }) }), (0, jsx_runtime_1.jsx)("td", { style: { fontSize: '0.8rem' }, children: historicalRow.pgn }), (0, jsx_runtime_1.jsx)("td", { style: { fontSize: '0.8rem' }, children: historicalRow.src }), (0, jsx_runtime_1.jsx)("td", { style: { fontSize: '0.8rem' }, children: historicalRow.dst }), (0, jsx_runtime_1.jsx)("td", { style: { fontSize: '0.8rem' }, children: (0, jsx_runtime_1.jsx)("span", { style: { fontFamily: 'monospace' }, children: historicalRow.getDefinition().Description }) })] }, `${rowKey}-history-${index}`))) })] })] }) }) }) }))] }, rowKey));
                    }) })] }) }));
};
exports.DataList = DataList;
